import React from 'react';
import { Typography, theme } from 'antd';

interface FormSectionProps {
  /** Section heading, rendered as a small uppercase secondary label. */
  title: React.ReactNode;
  /** Optional muted icon shown before the heading. */
  icon?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Groups related create-appointment fields under a consistent section heading.
 * Children are stacked with a uniform gap; `Form.Item` bottom margins are kept so validation
 * messages still have room.
 */
export const FormSection: React.FC<FormSectionProps> = ({ title, icon, children }) => {
  const { token } = theme.useToken();

  return (
    <section style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
      <Typography.Text
        type="secondary"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: token.marginXS,
          marginBottom: token.marginSM,
          fontSize: token.fontSizeSM,
          fontWeight: 600,
          letterSpacing: 0.5,
          textTransform: 'uppercase'
        }}
      >
        {icon ? <span style={{ color: token.colorTextTertiary, display: 'inline-flex' }}>{icon}</span> : null}
        {title}
      </Typography.Text>
      {children}
    </section>
  );
};
